import 'bootstrap';



//////////////////
// WEBPACK FOOTER
// ./assets/js/src/vendors.js
// module id = 1
// module chunks = 0